import { DrawerBody, DrawerHeader, DrawerContent, Text, Flex, Button, Icon, Grid, GridItem, Image } from '@chakra-ui/react';
import { ArrowBackIcon } from '@chakra-ui/icons';
import MyDiv from './payrollSumarryCard.style';
import TotalSelectedEmployeeIcon from '../../../../assets/images/TotalSelectedEmployeeIcon.svg';
import GrossSalaryIcon from '../../../../assets/images/GrossSalarryIcon.svg';
import TotalBonusIcon from '../../../../assets/images/TotalBonusIcon.svg';
import DeductionsIcon from '../../../../assets/images/DeductionsIconPayroll.svg';
import NetPayIcon from '../../../../assets/images/NetpayTotalIcon.svg';
const cards = [
  { label: "Total Selected Employees", icon: TotalSelectedEmployeeIcon, count: '100' },
  { label: "Gross Salary Total", icon: GrossSalaryIcon, count: '₹100' },
  { label: "Total Bonus", icon: TotalBonusIcon, count: '₹100' },
  { label: "Deductions", icon: DeductionsIcon, content: '--', count: '₹100' },
  { label: "Net pay Total", icon: NetPayIcon, content: '--', count: '₹100', fullWidth: true },];
const PayrollSummaryCard = (props: any) => {
  return (
    <MyDiv>
      <DrawerContent maxH="100vh" >
        <DrawerHeader borderBottomWidth="1px">
          <Flex align="center" gap={2}>
            <ArrowBackIcon cursor="pointer" onClick={props.onClose} />
            <Text fontWeight="bold">View Payroll Summary</Text>
          </Flex>
        </DrawerHeader>

        <DrawerBody display="flex" flexDirection="column" justifyContent="space-between">
          <Grid templateColumns="repeat(2, 1fr)" gap={4}>
            {cards.map((card, index) => (
              <GridItem key={index} colSpan={card.fullWidth ? 2 : 1} className='card_box ' >
                <Flex align="center" gap={2} mb={3} pt={2} pl={2}>
                  <Image src={card.icon} alt={card.label} />
                  <Text >{card.label}</Text>
                </Flex>
                <Text className="card_value " pl={2} mb={2}>{card.count}</Text>
              </GridItem>
            ))}
          </Grid>
          <Flex justify="flex-end" gap={4} >
            <Button bg={' #006838'}
              color="white" _hover={{ bg: '#006838', }} className='txt'>
              Download Data
            </Button>
            <Button bg={' #006838'}
              color="white" _hover={{ bg: '#006838', }}
              onClick={() => { props.setAlert(true); props.onClose() }}
            >Submit for Approval</Button>
          </Flex>
        </DrawerBody>
      </DrawerContent>
    </MyDiv>
  );
};

export default PayrollSummaryCard;
